import { inject, Injectable } from "@angular/core";
import { from, Observable, ReplaySubject } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DismissActivityCommand } from "~app/common/components/footer/DismissActivityCommand";
import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";
import { ActivityStatus } from "~app/common/models/constants";
import { CommandService } from "~app/common/services/cqs/command.service";
import { CommandManager, ICommandManager } from "~app/common/services/cqs/commandManager";
import { IActivityResultDto } from "~app/pages/start/aktiviteter/aktiviteter.models";
import { ApiClientService } from "./api-client.service";

@Injectable({
    providedIn: "root"
})
export class AnvandareService {
    aktiviteter$ = new ReplaySubject<IActivityResultDto>(1);

    private readonly apiClientService = inject(ApiClientService);
    private readonly busyService = inject(BusyService);
    private readonly commandManager: ICommandManager;
    private readonly commandService = inject(CommandService);

    constructor() {
        this.commandManager = new CommandManager();
        this.getAktivitetshistorik();
    }

    dismissActivities(id: number[], dissmissForAll = false) {
        id.forEach(x => {
            this.commandManager.updateCommand(new DismissActivityCommand(x, dissmissForAll));
        });

        const work = from(this.commandService.pushCommands(this.commandManager));

        this.busyService
            .addWork(work)
            .subscribe(() => {
                this.commandManager.clear();
                this.getAktivitetshistorik();
            });
    }

    getActivityStatusIcon(status: string): string {
        switch (status) {
            case ActivityStatus.Ok: {
                return "far fa-check-circle success";
            }
            case ActivityStatus.Fel: {
                return "far fa-exclamation-triangle error";
            }
            case ActivityStatus.Pagaende: {
                return "fas fa-spinner fa-spin";
            }
            default:
                return "far fa-exclamation-square";
        }
    }

    getAktivitetshistorik() {
        return this.apiClientService.get<IActivityResultDto>("anvandare/activity", false).subscribe(x => {
            this.aktiviteter$.next(x);
        });
    }

    getCurrentUserId() {
        return this.apiClientService.get<number>("anvandare/getCurrentUserId", true);
    }

    searchForAnvandareTypeahead(input: string): Observable<TypeAheadDTO[]> {
        return this.apiClientService.get<TypeAheadDTO[]>(`anvandare/searchForAnvandareTypeahead?input=${input}`, true);
    }
}
